<template>
  <div class="indexsfooter">
    <div class="img-content" style="display: flex; justify-content: center">
      <div class="bottom-left">
        <p>{{ $t('footer.contactUs') }}</p>
        <p>
          联系邮箱：trumpdoge666888@outlook.com<br />
          <!-- 咨询电话：{{ companyInfo.mobile }}<br> <br> -->
        </p>
        <!-- <p>公司地址</p>
        <p>{{ companyInfo.address }}</p> -->
      </div>
      <div class="bottom-right mobileHidden">
        <!-- <ul>
				<li>产品中心</li>
				<li><a href="javascript:void(0)">外卖跑腿</a></li>
				<li><a href="javascript:void(0)">人员管理系统</a></li>
				<li><a href="javascript:void(0)">上门服务</a></li>
				<li><a href="javascript:void(0)">门店经营管理系统</a></li>
				<li><a href="javascript:void(0)">汽车后市场</a></li>
				<li><a href="javascript:void(0)">社区团购</a></li>
				<li><a href="javascript:void(0)">门店会员管理系统</a></li>
				<li><a href="javascript:void(0)">相亲交友系统</a></li>
				<li><a href="javascript:void(0)">短剧视频平台</a></li>
			</ul>
			<ul>
				<li>软件开发</li>
				<li><a href="javascript:void(0)">APP开发</a></li>
				<li><a href="javascript:void(0)">小程序开发</a></li>
				<li><a href="javascript:void(0)">H5开发</a></li>
				<li><a href="javascript:void(0)">电商系统开发</a></li>
				<li><a href="javascript:void(0)">网站建设</a></li>
				<li><a href="javascript:void(0)">软件人力外包</a></li>
			</ul>
			<ul>
				<li>解决方案</li>
				<li><a href="javascript:void(0)">新零售O2O</a></li>
				<li><a href="javascript:void(0)">跨境电商</a></li>
				<li><a href="javascript:void(0)">智慧社区/物业系统</a></li>
				<li><a href="javascript:void(0)">母婴电商</a></li>
				<li><a href="javascript:void(0)">企业培训</a></li>
				<li><a href="javascript:void(0)">智能软硬件</a></li>
				<li><a href="javascript:void(0)">生鲜电商</a></li>
				<li><a href="javascript:void(0)">企业信息化管理系统</a></li>
				<li><a href="javascript:void(0)">农村电商</a></li>
				<li><a href="javascript:void(0)">4G远程遥控车</a></li>
			</ul>			 -->
        <!-- <ul>
          <li>公司微信</li>
          <li class="bottom-img">
            <img
              :src="'https://www.limingsoftware.top' + companyInfo.qrcode_image"
              width="109"
            />
          </li>
        </ul> -->
        <div class="clear"></div>
      </div>
      <div class="clear"></div>
    </div>
    <!-- <div class="img-content tianj mobileHidden" style="margin-top: 40px">
      <span class="tianj_a"
        >热门搜索： <span>app开发</span> <span>app定制开发</span>
        <span>app开发公司</span> <span>软件开发</span>
        <span>软件外包公司</span> <span>小程序</span>
        <span>智慧社区解决方案</span> <span>智慧城市</span>
        <span>智慧生活</span>
      </span>
    </div>
    <div class="copyright phone-copy mobileHidden">
      Copyright Reserved ©黎明软件科技&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <a
        href="http://beian.miit.gov.cn"
        target="_blank"
        style="color: rgb(111, 114, 125)"
        >{{ companyInfo.filing }}</a
      >
    </div> -->
    <!-- <div class="clear"></div> -->
  </div>
</template>

<script>
export default {
  name: 'fot',
  data() {
    return {
      companyInfo: JSON.parse(localStorage.getItem('companyInfo')),
    };
  },
  mounted() {
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    this.$root.$off('language-changed');
  },
  // mounted() {
  // 	console.log(this.companyInfo);
  // }
};
</script>

<style scoped>
.indexsfooter {
  color: var(--text-secondary);
  font-size: 14px;
  margin: 0;
  background: var(--bg-secondary);
  padding: 60px 0 30px 0;
  box-sizing: content-box;
  border-top: 1px solid var(--border-color);
}
.img-content {
  color: #555;
  font-size: 14px;
  box-sizing: border-box;
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}
.bottom-left {
  float: left;
  width: 600px;
}

.bottom-left p:nth-child(1),
.bottom-left p:nth-child(3),
.bottom-left p:nth-child(5) {
  font-size: 18px;
  color: var(--text-primary);
  margin: 20px 0;
}

.bottom-left a {
  color: var(--accent-light);
}

.bottom-left p:nth-child(1) {
  margin-top: 0;
}

.bottom-left p:nth-child(2) {
  font-size: 28px;
  color: var(--text-primary);
}

.bottom-left p:nth-child(4),
.bottom-left p:nth-child(6) {
  font-size: 14px;
  color: var(--text-tertiary);
  line-height: 25px;
}
.bottom-right {
  /* width: 880px; */
  float: right;
  display: flex;
  justify-content: space-between;
}

.bottom-right ul {
  list-style: none;
  width: 200px;
}

.bottom-right ul li {
  font-size: 14px;
  color: var(--text-tertiary);
}
.bottom-right ul li.bottom-img {
  width: 160px;
}

.bottom-right ul li a {
  display: block;
  line-height: 26px;
  margin: 4px 0;
  color: var(--text-tertiary);
}

.bottom-right ul li a:hover {
  color: var(--accent-light);
}

.bottom-right ul li:nth-child(1) {
  font-size: 18px;
  color: var(--text-primary);
  margin-bottom: 30px;
}
.clear {
  clear: both;
}
.indexsfooter .img-content,
.img-content {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  /*background-color: greenyellow;*/
}

.indexsfooter .img-content,
.img-content img {
  width: 100%;
}
.indexsfooter .tianj {
  height: 39px;
  line-height: 49px;
  font-size: 12px;
  color: var(--text-tertiary);
}
.indexsfooter .tianj > span:nth-child(2) {
  display: none;
}

.indexsfooter .tianj_a > span {
  margin-right: 5px;
}

.indexsfooter .link > .tianj_b {
  color: var(--text-tertiary);
  font-size: 16px;
  margin: 15px 0;
}
.indexsfooter .tianj_a > span {
  margin-right: 5px;
}
.indexsfooter .copyright {
  color: var(--text-tertiary);
  margin-top: 20px;
  text-align: center;
  font-size: 14px;
}
</style>
